import CopyableInputContainer from './CopyableInputContainer'
export default CopyableInputContainer
